import {GetStaticPaths, GetStaticProps} from 'next';

import {Layout, LayoutProps} from 'src/components/layout/Layout';
import {ProductsIndexPageTemplate} from 'src/components/products-index-page';
import {
  isSupportedLocale,
  isValidRegion,
  getCombinedRegionsAndLocales,
} from 'src/config';
import {getAvailableContentfulProducts} from 'src/features/product/data';
import {IProduct} from 'src/utils/contentful';

interface AllProductsPageProps extends Omit<LayoutProps, 'seo'> {
  products: IProduct[];
}

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = getCombinedRegionsAndLocales().map(({region, locale}) => ({
    params: {region, locale},
  }));

  return {paths, fallback: false};
};

export const getStaticProps: GetStaticProps = async (ctx) => {
  const {params} = ctx;

  if (!params) {
    throw new Error('could not find product listing page params');
  }

  const {locale, region} = params;

  if (!isSupportedLocale(locale)) {
    throw new Error(`Invalid locale. Received: ${locale}`);
  }

  if (!isValidRegion(region)) {
    throw new Error(`Invalid region. Received: ${region}`);
  }

  const availableContentfulProducts = getAvailableContentfulProducts({
    region,
    locale,
  });

  return {
    props: {
      products: availableContentfulProducts,
      pageContext: {region, locale},
    },
  };
};

const AllProductsPage: React.FC<
  React.PropsWithChildren<AllProductsPageProps>
> = (props) => {
  const {products, pageContext} = props;

  return (
    <Layout
      seo={{
        title: 'Products', // TODO Localize these strings
        description: 'All Stryd Products', // TODO Localize these strings
        includeInRegions: ['all'],
        slug: 'products',
        slugPrefix: '',
        noIndex: false,
      }}
      pageContext={pageContext}
    >
      <ProductsIndexPageTemplate products={products} />
    </Layout>
  );
};

export default AllProductsPage;
